import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { USWDSDropdownComponent } from "./dropdown.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    USWDSDropdownComponent
  ],
  exports: [
    USWDSDropdownComponent
  ]
})
export class USWDSDropdownModule {}
